import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here
import Config from "../../../../Config.jsx";

import Localization from "../../../../Localization.jsx"

import StagePicker from "../../../../views/StagePicker.jsx";

import {
  Grid,
  Card,
  CardHeader,
  CardMedia,
  Button,
  TextField,
  Switch,
  FormControlLabel,
} from '@material-ui/core'

import FormHelperText from '@material-ui/core/FormHelperText';
import FilePickerCard from "../../../../views/FilePickerCard.jsx"

import {
  grey,
} from '@material-ui/core/colors'

const playbackKind = 3; // Portal

class PortalForm extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    var defaultPayloadData = {
      portal_arr: [
        {"stage_id": 0, "tn_id": -1, "custom_name": "", "custom_image_id": 0, "show_image": true, "enabled": true},
        {"stage_id": 0, "tn_id": -1, "custom_name": "", "custom_image_id": 0, "show_image": true, "enabled": true},
        {"stage_id": 0, "tn_id": -1, "custom_name": "", "custom_image_id": 0, "show_image": true, "enabled": true},
        {"stage_id": 0, "tn_id": -1, "custom_name": "", "custom_image_id": 0, "show_image": true, "enabled": true},
      ],
    };

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      content: "",
      targetPortalIndex: -1,
      payloadData: defaultPayloadData,
      custom_images_id_arr: [0, 0, 0, 0],
    };
    autoBind(this);

    if (this.props.playbackData != null) {
      this.state.content = this.props.playbackData['content'];
      this.state.payloadData = (this.props.playbackData['payload'] != ""? JSON.parse(this.props.playbackData['payload']) : defaultPayloadData);
    
      // Ensure each portal object has the necessary properties
      this.state.payloadData['portal_arr'].forEach(portal => {
        portal['custom_name'] = portal['custom_name'] || "";
        portal['custom_image_id'] = portal['custom_image_id'] || 0;
        portal['show_image'] = portal.hasOwnProperty('show_image') ? portal['show_image'] : true;
        portal['enabled'] = portal.hasOwnProperty('enabled') ? portal['enabled'] : true;
      });
    
      this.state.custom_images_id_arr = [this.state.payloadData['portal_arr'][0]['custom_image_id'], this.state.payloadData['portal_arr'][1]['custom_image_id'], this.state.payloadData['portal_arr'][2]['custom_image_id'], this.state.payloadData['portal_arr'][3]['custom_image_id']];
    }    
  }

  onContentChanged(e) {
    this.setState({
      content: e.target.value,
    });
    this.state.content = e.target.value;
  }

  selectStageClicked(index) {
    this.setState({
      targetPortalIndex: index,
    });
    this.state.targetPortalIndex = index;

    this.refs.stagePicker.setState({
      open: true,
    });
  }

  onStagePicked(stageID) {
    let payloadData = this.state.payloadData;
    let stageData = this.props.root.refs.stageViewerPage.getStageDataById(stageID);
    let tn_id = (stageData['movie_list'][0] == null? -1 : stageData['movie_list'][0]['tn_file_id']);
    payloadData['portal_arr'][this.state.targetPortalIndex]['stage_id'] = stageID;
    payloadData['portal_arr'][this.state.targetPortalIndex]['tn_id'] = tn_id;
    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;
  }

  onUploadSuccess(res, index) {
    let payloadData = this.state.payloadData;
    payloadData['portal_arr'][index]['custom_image_id'] = res['file_id'];
    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;
    // print payloadData
    console.log(payloadData);
  }

  onCustomNameChanged(e, index) {
    let payloadData = this.state.payloadData;
    payloadData['portal_arr'][index]['custom_name'] = e.target.value;
    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;
    console.log(payloadData);
  }

  handleShowImageChange(event, index) {
    let payloadData = this.state.payloadData;
    payloadData['portal_arr'][index]['show_image'] = event.target.checked;
    this.setState({ payloadData: payloadData });
    this.state.payloadData = payloadData;
  }
  
  handleEnabledChange(event, index) {
    let payloadData = this.state.payloadData;
    payloadData['portal_arr'][index]['enabled'] = event.target.checked;
    this.setState({ payloadData: payloadData });
    this.state.payloadData = payloadData;
  }  

  getStageChoice(index) {
    let stage_id = this.state.payloadData['portal_arr'][index]['stage_id'];
    let stageData = this.props.root.refs.stageViewerPage.getStageDataById(stage_id);
    let tn_path = "";
    let stage_name = "";
    if (stageData != null) {
      tn_path = (stageData['movie_list'][0] != null?
        Config.BASE_PATH() + stageData['movie_list'][0]['tn_path']
        : "");
      stage_name = stageData['stage_name'];
    }
  
    const isEnabled = this.state.payloadData['portal_arr'][index]['enabled'];
  
    return (
      <Grid item xs={12} sm={6} key={index}>
        <Card style={{margin:"5px", opacity: isEnabled ? 1 : 0.5}}>
          <CardHeader
            titleTypographyProps={{variant:"subtitle1"}}
            title={Localization.strings.DESTINATION + " " + (index + 1) + (stage_name == ""? "" : " - " + stage_name)}
            style={{backgroundColor: '#3f51b5', color: "white"}}
          />
          <div style={{ opacity: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={isEnabled}
                  onChange={(event) => this.handleEnabledChange(event, index)}
                  color="primary"
                />
              }
              label={Localization.strings.ENABLED}
              style={{padding:"10px"}}
            />
          </div>

          <CardMedia image="/" style={{display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:grey[200], height:"20vh", padding:"10px"}}>
            <If condition={isEnabled && (stageData == null || tn_path == "")}>
              <Then>
                <div>
                  <Button
                    onClick={()=>this.selectStageClicked(index)}
                    variant={stageData == null? "text" : "contained"}
                    color={stageData == null? "default" : "primary"}
                  >
                    {stageData == null? Localization.strings.SELECT_STAGE : stage_name}
                  </Button>
                </div>
              </Then>
              <Else>
                <img
                  style={{cursor: "pointer", maxHeight:"100%", maxWidth:"100%", display:"block", margin:"auto"}}
                  src={tn_path}
                  onClick={()=>this.selectStageClicked(index)}
                />
              </Else>
            </If>
          </CardMedia>
          <Grid container direction="row" alignItems="center" justify="space-between" style={{padding: '10px'}}>
            <Grid item>
              <TextField
                fullWidth
                label={Localization.strings.CUSTOM_NAME}
                value={this.state.payloadData['portal_arr'][index]['custom_name']}
                onChange={(e) => this.onCustomNameChanged(e, index)}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.payloadData['portal_arr'][index]['show_image']}
                    onChange={(event) => this.handleShowImageChange(event, index)}
                    color="primary"
                  />
                }
                label={Localization.strings.SHOW_IMAGE}
              />
            </Grid>
            {this.state.payloadData['portal_arr'][index]['show_image'] && isEnabled && (
              <div style={{margin:'0 0 0 0'}}>
                <FilePickerCard parent={this} root={this.props.root} ref="filePickerCard"
                  kind={2}
                  localeId={this.props.root.state.targetLocaleData['id']}
                  allowedExtension={Config.GET_ALLOWED_FILE_EXTENSION("image")}
                  index={index}
                  onUploadSuccess={(res) => this.onUploadSuccess(res, index)}
                  file_id={this.state.payloadData['portal_arr'][index]['custom_image_id']}
                />
              </div>
            )}
          </Grid>
        </Card>
      </Grid>
    );
  }
  

  validateInput() {
    let result = true;
    if (this.state.content.trim() === "") {
      this.props.root.addNotification("Description cannot be blank");
      result = false;
    }
  
    // Rule 1: At least one of the items in the portal_arr is enabled
    const isAnyPortalEnabled = this.state.payloadData.portal_arr.some(portal => portal.enabled);
    if (!isAnyPortalEnabled) {
      this.props.root.addNotification("At least one portal must be enabled");
      result = false;
    }
  
    // Rule 2: stage_id of enabled portal_arr must not equal to 0
    const isAnyEnabledPortalStageIdZero = this.state.payloadData.portal_arr.some(portal => portal.enabled && portal.stage_id === 0);
    if (isAnyEnabledPortalStageIdZero) {
      this.props.root.addNotification("The stage_id of enabled portals must not be 0");
      result = false;
    }
  
    return result;
  }
  

  updatePlayback(new_id) {
    let requestObj = {
      playback_id: new_id,
      kind: playbackKind,
      trigger_time: (this.props.playbackData? this.props.playbackData['trigger_time'] : this.props.root.refs.stageViewerPage.refs.stageDetailView.refs.stageMediaView.state.playbackTime),
      should_pause_video: Config.GET_PLAYBACK_CONFIG(playbackKind)['shouldPauseVideo'],
      pos_x: 0,
      pos_y: 0,
      countdown_limit: 0,
      content: this.state.content.trim(),
      payload: JSON.stringify(this.state.payloadData),
    };
    this.props.root.refs.API.request("update_playback", requestObj, this.props.parent.updatePlaybackOK, this.props.parent.updatePlaybackFailed);
  }

  render() {
    let destination = [];
    for (let i = 0; i < 4; i++) {
        destination.push(i);
    }

    return (
      <div>
        <StagePicker parent={this} root={this.props.root} ref="stagePicker"/>
        <Grid container spacing={2} alignItems="top">
          <Grid item xs={12} sm={2}>
            {Localization.strings.DESCRIPTION}
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              value={this.state.content}
              onChange={this.onContentChanged}
              helperText={Localization.strings.PORTAL_DESCRIPTION}
            />
          </Grid>
          {destination.map((row, i) => {
            return (
              this.getStageChoice(i)
            );
          })}
        </Grid>
      </div>
    )
  }
}

export default PortalForm;
